export default __webpack_public_path__ + "static/Survive-Japan-Knowing-Only-English-Free-Wifi-1d56c7626cbead168b059f6439819664.jpg";